import React, { useState, useRef, useEffect } from 'react';
import { ClientService } from '../../../services/clientService';
import './shortlistDetails.css';

const STATUS_OPTIONS = [
    'SHORTLISTED',
    'INTERVIEWED',
    'ON_HOLD',
    'HIRED',
    'REJECTED',
];

const ShortlistStatusDropdown = ({
    candidateId,
    folderId,
    currentStatus,
    historyNodeId,
    refreshShortlistDetails,
}) => {
    const [selectedStatus, setSelectedStatus] = useState(currentStatus);
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    const statusChanged = selectedStatus !== currentStatus;

    useEffect(() => {
        setSelectedStatus(currentStatus);
        setNote('');
        setError('');
        setOpen(false);
    }, [currentStatus]);


    const handleSubmit = async () => {

        setLoading(true);
        setError('');

        try {
            await ClientService.changeStatus({
                candidateId,
                folderId,
                shortlistStatus: selectedStatus,
                noteRequest: {
                    historyNodeId,
                    note: note.trim(),
                },
            });

            setNote('');
            refreshShortlistDetails();
        } catch (err) {
            setError('Failed to update status.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="sl-details-status-select" ref={containerRef}>
            <label className="sl-label">Status</label>

            {/* Custom dropdown */}
            <div
                className="sl-dropdown"
                onClick={() => !loading && setOpen(!open)}
            >
                {selectedStatus}
                <span className="sl-dropdown-arrow">&#9662;</span>
            </div>

            {open && (
                <div className="sl-dropdown-options">
                    {STATUS_OPTIONS.map((status) => (
                        <div
                            key={status}
                            className={`sl-dropdown-option ${status === selectedStatus ? 'sl-selected' : ''
                                }`}
                            onClick={() => {
                                setSelectedStatus(status);
                                setOpen(false);
                                setError('');
                            }}
                        >
                            {status}
                        </div>
                    ))}
                </div>
            )}

            {statusChanged && (
                <>
                    <textarea
                        className="sl-textarea mt-2"
                        rows={3}
                        placeholder="Add note"
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                    />

                    {error && <div className="sl-details-error">{error}</div>}

                    <button
                        className="btn sl-btn-orange mt-2"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        Change Status
                    </button>
                </>
            )}
        </div>
    );
};

export default ShortlistStatusDropdown;